module.exports = __webpack_public_path__ + "img/date7-icon.9a3761bc.png";